import { Injectable, Inject } from '@angular/core';
import { AChartComponent } from '../components/achart/achart.component';
import { ChartDisplayModeService } from './layoutDisplayModeService/layoutDisplayModeService.service';
import { ChartDisplayMode } from '../enums/ChartDisplayMode.list';
import { IAnnotation } from '../interfaces/IAnnotation';

@Injectable({
  providedIn: 'root'
})
export class AnnotationsService 
{
  public charts: { [chartId: string]: AChartComponent} = {};
  public annotations: IAnnotation[] = [];
  constructor(@Inject(ChartDisplayModeService) private displayModeService: ChartDisplayModeService) 
  {
    displayModeService.subscriber.subscribe(displayMode =>
    {
      
    })
  }

  removeAllFromCharts()
  {
    this.annotations.forEach(a => (<any>a.anychartAnnotation).remove());
  }
}
